import { render, staticRenderFns } from "./WarehouseDropdown.vue?vue&type=template&id=15f5360f&"
import script from "./WarehouseDropdown.vue?vue&type=script&lang=js&"
export * from "./WarehouseDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports